module.exports = __webpack_public_path__ + "static/media/ctaasa.bd85f4a2.png";